export default __webpack_public_path__ + "static/media/logo-blue.7f95321e.svg";